import { ElementType } from "react";

interface IconChipProps {
    icon: ElementType;
    className?: string;
    iconClassName?: string;
}

export function IconChip({ icon: Icon, className = "", iconClassName = "" }: IconChipProps) {
    return (
        <div className={`inline-flex h-10 w-10 items-center justify-center rounded-full
            bg-accent text-white ${className}`}>
            <Icon className={`h-5 w-5 ${iconClassName}`} />
        </div>
    );
}
